import { BasicDurations } from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import type { SearchAdvertisingParamsDefinition } from "./searchAdvertisingRoutes.types";

export const params: SearchAdvertisingParamsDefinition = {
    key: {
        type: "string",
        dynamic: false,
    },
    duration: {
        type: "string",
        value: BasicDurations.LAST_THREE_MONTHS,
    },
    webSource: {
        type: "string",
        value: devicesTypes.DESKTOP,
    },
    country: {
        type: "int",
        value: 999,
    },
    isWWW: {
        type: "string",
        value: "*",
    },
    selectedTab: {
        type: "string",
    },
    currency: {
        type: "string",
    },
    isMTD: {
        type: "boolean",
    },
    pageFilter: {
        type: "string",
    },
    selectedDomain: {
        type: "string",
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Change: {
        type: "string",
    },
    serp: {
        type: "string",
    },
    multiIncludeExcludeWebsites: {
        type: "string",
    },
    multiIncludeExcludeUrl: {
        type: "string",
    },
    multiIncludeExcludeKeywords: {
        type: "string",
    },
    selectedPageTab: {
        type: "string",
    },
    selectedSite: {
        type: "string",
    },
    sort: {
        type: "string",
    },
    asc: {
        type: "string",
    },
    // TODO: convert to array type when available
    includeTerms: {
        type: "string",
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    IncludeBranded: {
        type: "boolean",
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    IncludeNoneBranded: {
        type: "boolean",
    },
    volumeFromValue: {
        type: "string",
    },
    volumeToValue: {
        type: "string",
    },
    cpcFromValue: {
        type: "string",
    },
    cpcToValue: {
        type: "string",
    },
    source: {
        type: "string",
    },
    family: {
        type: "string",
    },
    trafficPreset: {
        type: "string",
    },
    comparedDuration: {
        type: "string",
    },
    orderby: {
        type: "string",
    },
    websiteType: {
        type: "string",
    },
    organicSearchType: {
        type: "string",
    },
    risingCompetitors: {
        type: "string",
    },
    newCompetitors: {
        type: "string",
    },
    category: {
        type: "string",
    },
    search: {
        type: "string",
    },
    mtd: {
        type: "string",
        value: "false",
    },
    tab: {
        type: "string",
    },
    domains: {
        type: "string",
    },
    type: {
        type: "string",
    },
    selectedCategory: {
        type: "string",
    },
    orderBy: {
        type: "string",
    },
    multiIncludeExcludeTitle: {
        type: "string",
    },
    keywordGroupId: {
        type: "string",
    },
    keywordsType: {
        type: "string",
    },
    activationSetId: {
        type: "string",
    },
} as const;

export const ROUTES = {
    landingPages: "adintelligence-searchadvertising.root.pageFrame.landingPages",
    textAndShoppingAds: "adintelligence-searchadvertising.root.pageFrame.textAndShoppingAds",
    keywords: "adintelligence-searchadvertising.root.pageFrame.keywords",
    topics: "adintelligence-searchadvertising.root.frame.topics",
    keywordAds: "adintelligence-searchadvertising.root.keywordFrame.ads",
    serpPlayers: "adintelligence-searchadvertising.root.keywordFrame.serpPlayers",
    keywordLandingPages: "adintelligence-searchadvertising.root.keywordFrame.keywordLandingPages",
    monitorKeywordsHome: "adintelligence-searchadvertising.root.monitorKeywordsHome",
    monitorKeywords: "adintelligence-searchadvertising.root.monitorKeywordsRoot.monitorKeywords",
} as const;
